export default __webpack_public_path__ + "static/media/beispiel-vegistrierungscode.fa34eb22.png";